<script>
export default {
    name: "ConstructionDocumentTab",
    props: {
        construction: {required: true}
    }
}
</script>

<template>
    <div
         v-if="construction.documents && construction.documents.length > 0">
        <div class="row">
            <div class="col-lg-12">
                <div class="well well-lg text-center" v-if="!construction.documents.length">
                    Não há documentos cadastrados
                </div>
                <table class="table table-light table-hover table-condensed" v-if="construction.documents.length">
                    <tbody>
                    <tr v-for="document in construction.documents">
                        <td>{{document.name}}</td>
                        <td width="200" style="text-align: right">
                            <a class="btn orange" :href="document.url" target="_blank"><i class="fa fa-download"></i></a>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// ConstructionDocumentTab.vue?5f68e7fe